import React from 'react'

import styled from '@emotion/styled';
import { TweenMax, Power1 } from 'gsap';
import { InView } from 'react-intersection-observer';
import { breakP } from '../../_style';

export default class ParallaxImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {windowH: 0, isSp: false};
    if(this.state.isSp && this.props.isPcOnly) return;
    this.el = null;
    this.handler = this.fun.bind(this);
    this.img = null;
    this.bg = null;
    this.mask = null;
  }

  componentDidMount() {
    this.setState({windowH: window.innerHeight, isSp: breakP >= window.innerWidth});
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handler);
  }

  fun() {
    if(this.props.level === 0) return;
    const ele = this.el;
    const level = this.props.level * (this.state.isSp ? 0.015 : 0.01);
    const t_height = ele.clientHeight;
    const screenHeight = window.innerHeight;
    const scrollTop = window.pageYOffset;
    const offsetY = ele.getBoundingClientRect().top;
    const t_top = offsetY + scrollTop;
    const t_position = offsetY - screenHeight;
    const t_bottom = t_position + t_height;
    const moveDis = Math.floor((scrollTop - t_top + (screenHeight - t_height) / 2) * level * 100) / 100;
    const direction = this.props.down ? -1 : 1;
    const baseMaskDelay = this.state.isSp ? 0.1 : 0.3;
    let ticking = false;
    let animation;
    if (!ticking) {
      animation = window.requestAnimationFrame(() => {
        const duration = this.props.firstDur && this.isFirst ? this.props.firstDur : 0.4;
        ticking = false;

        if (-screenHeight <= t_bottom && t_position < 0) {
          TweenMax.to(ele, duration, {
            y: -moveDis * direction,
            ease: Power1.easeOut,
            delay: this.props.bg ? this.isFirst && this.props.delay ? this.props.delay + baseMaskDelay : baseMaskDelay : 0
          });
        }
      });

      ticking = true;
    } else {
      window.cancelAnimationFrame(animation);
    }
  }

  parallax(e) {
    if(e.isIntersecting) {
      window.addEventListener('scroll', this.handler);
    } else {
      window.removeEventListener('scroll', this.handler);
    }
  }

  render() {
    const Container = styled.div`
      position: relative;
      overflow: hidden;
    `
    const Inner = styled.div`

    `
    if(this.state.isSp && this.props.isPcOnly) {
      return null
    } else {
      return (
        <InView as={Container} onChange={(inView, entry) => { this.parallax(entry); }}>
          <Inner ref={div => (this.el = div)}>
            {this.props.children}
          </Inner>
        </InView>
      )
    }
  }
}
